import { render, staticRenderFns } from "./ScenkonstDigitalStage.vue?vue&type=template&id=1df5ae7f&"
import script from "./ScenkonstDigitalStage.vue?vue&type=script&lang=ts&"
export * from "./ScenkonstDigitalStage.vue?vue&type=script&lang=ts&"
import style0 from "./ScenkonstDigitalStage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockDigitalScene: require('/tmp/build_453bf6d7/src/components/block/DigitalScene.vue').default})
